export const validPostalCode = new RegExp(/^[0-9]{5}$/)